
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/most-popular",
      function () {
        return require("private-next-pages/most-popular/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/most-popular"])
      });
    }
  